import { apiClient } from '@tradermind/shared/api';

// Tickets API - 使用shared库的apiClient，自动处理认证和token刷新
export const ticketsApi = {
  getMyTickets: (params?: { status?: string; page?: number; page_size?: number }) =>
    apiClient.get('/tickets', { params }),
  
  getTicket: (id: string) =>
    apiClient.get(`/tickets/${id}`),
  
  createTicket: (data: {
    subject: string;
    description: string;
    priority?: string;
    category?: string;
  }) => apiClient.post('/tickets', data),
  
  addReply: (id: string, data: { message: string }) =>
    apiClient.post(`/tickets/${id}/reply`, data),
};
